import { ISelectOption } from '@smartshell/ui-kit';

import { TLocalesKeys } from './localization';
import { ELogType, ETariffType } from './types';

export const RESOLUTION_THRESHOLD = 1648;

export const HOST_GROUPS_LOADED_EVENT = 'HOST_GROUPS_LOADED';

export const ALL_LETTERS_AND_DIGITS_REGEXP = /[A-Za-zА-Яа-я0-9]/;

export const DEFAULT_EVENTS_TYPE_FILTER: Array<ELogType> = [
  ELogType.CLUB_CREATED,
  ELogType.TELEGRAM_LINKED,
  ELogType.TELEGRAM_UNLINKED,
  ELogType.PAYMENT_CREATED,
  ELogType.BONUS_PAYMENT_CREATED,
  ELogType.BONUS_UPDATED,
  ELogType.PAYMENT_REFUND,
  ELogType.CASH_ORDER_CREATED,
  ELogType.DEPOSIT_ADDED_ONLINE,
  ELogType.DEPOSIT_UPDATED,
  ELogType.CLIENT_SESSION_STARTED,
  ELogType.CLIENT_SESSION_PROLONGED,
  ELogType.CLIENT_SESSION_FINISHED,
  ELogType.CLIENT_SESSION_HOST_CHANGED,
  ELogType.CLIENT_SESSION_PAUSED,
  ELogType.CLIENT_SESSION_UNPAUSED,
  ELogType.CLIENT_SESSION_UNPAUSED_AUTO,
  ELogType.HOST_PUNISHED,
  ELogType.SEND_RESET_CODE,
  ELogType.SEND_VERIFY_CODE,
  ELogType.USER_RESET_PASSWORD,
  ELogType.USER_REGISTERED,
  ELogType.USER_BANNED,
  ELogType.USER_UNBANNED,
  ELogType.USER_DISCOUNT_UPDATED,
  ELogType.CLIENT_AUTHORIZED_FROM_HOST,
  ELogType.WORKER_AUTHORIZED_FROM_BILLING,
  ELogType.WORKER_AUTHORIZED_FROM_HOST,
  ELogType.WORK_SHIFT_STARTED,
  ELogType.WORK_SHIFT_FINISHED,
  ELogType.HOST_GROUP_CREATED,
  ELogType.HOST_GROUP_DELETED,
  ELogType.HOST_CREATED,
  ELogType.HOST_SWITCHED_GROUP,
  ELogType.WORKER_CREATED,
  ELogType.WORKER_UPDATED,
  ELogType.WORKER_DELETED,
  ELogType.WORKER_ENABLED,
  ELogType.USER_BANNED,
  ELogType.USER_DISCOUNT_UPDATED,
  ELogType.DEPOSIT_UPDATED,
  ELogType.BONUS_UPDATED,
  ELogType.TARIFF_CREATED,
  ELogType.TARIFF_UPDATED,
  ELogType.TARIFF_DELETED,
  ELogType.SERVICE_CREATED,
  ELogType.SERVICE_UPDATED,
  ELogType.SERVICE_DELETED,
  ELogType.GOOD_CREATED,
  ELogType.GOOD_UPDATED,
  ELogType.GOOD_DELETED,
  ELogType.GOOD_LOW_STOCK_THRESHOLD_REACHED,
  ELogType.DISCOUNT_CREATED,
  ELogType.DISCOUNT_UPDATED,
  ELogType.DISCOUNT_DELETED,
  ELogType.PROMO_CODE_CREATED,
  ELogType.PROMO_CODE_UPDATED,
  ELogType.PROMO_CODE_DELETED,
  ELogType.PROMO_CODE_USED,
  ELogType.PROMO_CODE_EXPIRED,
  ELogType.PROMO_CAMPAIGN_CREATED,
  ELogType.PROMO_CAMPAIGN_UPDATED,
  ELogType.PROMO_CAMPAIGN_DELETED,
  ELogType.PROMO_CAMPAIGN_CODES_GENERATED,
  ELogType.PROMO_CAMPAIGN_EXPIRED,
  ELogType.TASK_ADDED,
  ELogType.WAREHOUSE_GOODS_ADDED,
  ELogType.WAREHOUSE_GOODS_DISPOSED,
  ELogType.HOST_HARDWARE_CHANGED,
  ELogType.HOST_HARDWARE_APPLIED,
  ELogType.SHELL_DISABLED,
  ELogType.SHELL_ENABLED,
  ELogType.SHELL_HIGH_ACCESS_DISABLED,
  ELogType.SHELL_HIGH_ACCESS_ENABLED,
  ELogType.HOST_ADMIN_CALLED,
  ELogType.HOST_ADMIN_CALL_CHECKED,
  ELogType.HOST_ADMIN_CALL_FAILED,
  ELogType.CLUB_COMMENT_CREATED,
  ELogType.ACHIEVEMENT_CREATED,
  ELogType.ACHIEVEMENT_DELETED,
  ELogType.ACHIEVEMENT_ASSIGNED,
  ELogType.BOOKING_CREATED,
  ELogType.BOOKING_CANCELED,
  ELogType.BOOKING_FAILED_TO_START,
  ELogType.BOOKING_UPDATED,
  ELogType.BOOKING_CONFIRMED,
  ELogType.COMBO_CREATED,
  ELogType.COMBO_UPDATED,
  ELogType.COMBO_DELETED,
  ELogType.POST_PAYMENT_CANCELED,
  ELogType.DEBT_ACTIVATED,
  ELogType.SETTINGS_UPDATED,
  ELogType.USER_GROUP_UPDATED,
  ELogType.USER_GROUP_CREATED,
  ELogType.USER_GROUP_DELETED,
  ELogType.USER_CHANGED_GROUP,
  ELogType.GOOD_CATEGORY_CREATED,
  ELogType.GOOD_CATEGORY_UPDATED,
  ELogType.GOOD_CATEGORY_DELETED,
  ELogType.USER_VERIFIED,
  ELogType.USER_DEPOSIT_TRANSFERRED,
  ELogType.BONUS_UPDATED,
  ELogType.NEWS_CREATED,
  ELogType.NEWS_DELETED,
  ELogType.NEWS_UPDATED,
  ELogType.HOST_QR_GENERATE,
  ELogType.SHORTCUT_CREATED,
  ELogType.SHORTCUT_UPDATED,
  ELogType.SHORTCUT_DELETED,
  ELogType.SETTINGS_COPIED,
  ELogType.ADVERTISEMENT_APPROVED,
  ELogType.ADVERTISEMENT_MODERATION,
  ELogType.ADVERTISEMENT_REJECTED,
  ELogType.ADVERTISEMENT_MANUAL_COMPLETED,
];

export enum EGroupColors {
  BLUE = '#2C87FD',
  VIOLET = '#7C62FF',
  PINK = '#B540B8',
  GREEN = '#27AE60',
  WAVE = '#00A8BF',
}
export const DEFAULT_GROUP_COLOR = EGroupColors.BLUE;

export const TYPES_MAP: Record<ETariffType, TLocalesKeys> = {
  [ETariffType.PAUSABLE]: 'tariff.type.pause',
  [ETariffType.PACKET]: 'tariff.type.package',
  [ETariffType.PER_MINUTE]: 'tariff.type.minute',
  [ETariffType.FIXED]: 'tariff.type.fix',
};

export const serviceNameOptions: ISelectOption[] = [
  {
    title: 'Аренда компьютерного оборудования',
    value: 'Аренда компьютерного оборудования',
  },
  {
    title: 'Аренда игрового места',
    value: 'Аренда игрового места',
  },
  {
    title: 'Игровое время',
    value: 'Игровое время',
  },
];

export const russianToEnglishDict: Record<string, string> = {
  й: 'q',
  ц: 'w',
  у: 'e',
  к: 'r',
  е: 't',
  н: 'y',
  г: 'u',
  ш: 'i',
  щ: 'o',
  з: 'p',
  х: '[',
  ъ: ']',
  ф: 'a',
  ы: 's',
  в: 'd',
  а: 'f',
  п: 'g',
  р: 'h',
  о: 'j',
  л: 'k',
  д: 'l',
  ж: ';',
  э: "'",
  я: 'z',
  ч: 'x',
  с: 'c',
  м: 'v',
  и: 'b',
  т: 'n',
  ь: 'm',
  б: ',',
  ю: '.',
  ё: '`',

  Й: 'Q',
  Ц: 'W',
  У: 'E',
  К: 'R',
  Е: 'T',
  Н: 'Y',
  Г: 'U',
  Ш: 'I',
  Щ: 'O',
  З: 'P',
  Х: '{',
  Ъ: '}',
  Ф: 'A',
  Ы: 'S',
  В: 'D',
  А: 'F',
  П: 'G',
  Р: 'H',
  О: 'J',
  Л: 'K',
  Д: 'L',
  Ж: ':',
  Э: '"',
  Я: 'Z',
  Ч: 'X',
  С: 'C',
  М: 'V',
  И: 'B',
  Т: 'N',
  Ь: 'M',
  Б: '<',
  Ю: '>',
  Ё: '~',
  '№': '#',
  ',': '?',
  '?': '&',
  '.': '/',
};
